import type { Organization } from "@/types/organization";
import { CUSTOM_MODEL_PATTERN, STYLE_GUIDE_SECTIONS } from "@/components/modals/organizationSettings/constants";
import type {
  StyleGuideFormValues,
  StyleGuidePayload,
  StyleGuideSectionKey,
} from "@/components/modals/organizationSettings/types";

export const parseSsoDomains = (value: string): string[] => [
  ...new Set(
    value
      .split(/[\s,]+/)
      .map(domain => domain.trim().toLowerCase())
      .filter(Boolean),
  ),
];

export const getApiErrorMessage = (error: unknown): string | undefined => {
  const data = (error as { data?: { data?: unknown[] } })?.data?.data;
  return Array.isArray(data) && typeof data[0] === "string" ? data[0] : undefined;
};

export const getCustomLlmModelError = (model: string) => {
  const trimmed = model.trim();
  if (!trimmed) return "Enter a custom model name";
  if (!CUSTOM_MODEL_PATTERN.test(trimmed)) {
    return "Use 128 or fewer characters: letters, numbers, dots, dashes, colons, or slashes";
  }
  return null;
};

const mapStyleGuideSections = <T>(getValue: (key: StyleGuideSectionKey) => T): Record<StyleGuideSectionKey, T> =>
  Object.fromEntries(STYLE_GUIDE_SECTIONS.map(({ key }) => [key, getValue(key)])) as Record<StyleGuideSectionKey, T>;

export const getEmptyStyleGuideValues = (): StyleGuideFormValues => mapStyleGuideSections(() => "");

export const getStyleGuideValues = (organization: Organization): StyleGuideFormValues =>
  mapStyleGuideSections(key => organization[key] ?? "");

// Empty sections are sent as null so the backend clears the organisation override.
export const getStyleGuidePayload = (data: StyleGuideFormValues): StyleGuidePayload =>
  mapStyleGuideSections(key => data[key] || null);
